<template>
    <div class="loading text-center row justify-content-center my-5">
        <div class="col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4 my-5">
            <h2 class="text-white mb-5"><strong>{{text || $t('common.loading')}}</strong></h2>
            <loading-bar/>
        </div>
    </div>
</template>

<script>
import LoadingBar from '@/components/common/LoadingBar';

export default {
    name: 'Loading',
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        LoadingBar
    }
};
</script>